import { skillImagesData } from "@/lib/_data/skillImagesData";
import type { HoveredLinkData, MenuItemData } from "@/types/data";

// Re-export types for convenience
export type {
  HoveredLinkData,
  MenuItemContent,
  MenuItemData,
  ProductItemData,
} from "@/types/data";

// Helper function to get unique skills by category
function getUniqueSkills() {
  const seen = new Set<string>();
  return skillImagesData.filter((skill) => {
    if (seen.has(skill.category)) {
      return false;
    }
    seen.add(skill.category);
    return true;
  });
}

// Generate trade types links dynamically from skillImagesData
function generateTradeTypesLinks(): HoveredLinkData[][] {
  const uniqueSkills = getUniqueSkills();
  const itemsPerColumn = Math.ceil(uniqueSkills.length / 4);
  const columns: HoveredLinkData[][] = [[], [], [], []];

  uniqueSkills.forEach((skill, index) => {
    const columnIndex = Math.floor(index / itemsPerColumn);
    const column = columns[columnIndex];
    if (columnIndex < 4 && column) {
      column.push({
        href: `/home/trade/${encodeURIComponent(skill.category)}`,
        label: skill.title,
      });
    }
  });

  // Filter out empty columns
  return columns.filter((column) => column.length > 0);
}

export const navMenuData: MenuItemData[] = [
  {
    label: "How it works",
    href: "/home/how-it-works",
    content: {
      type: "links",
      layout: "grid",
      items: [
        [
          { href: "/home/style/button", label: "Buttons Guide" },
          { href: "/home/style/color", label: "Color Guide" },
          { href: "/home/style/modal", label: "Modal Guide" },
          { href: "/home/style/components", label: "Components Guide" },
        ],

        [
          { href: "/home/job-details/public", label: "Public View" },
          { href: "/home/job-details/owner", label: "Owner View" },
          { href: "/home/job-details/applicant", label: "Applicant View" },
          { href: "/home/job-details/modal", label: "Modal View" },
        ],
        [
          { href: "/home/trade/profile", label: "Tradie Profile View" },
          { href: "/home/trade/search", label: "Tradie Search View" },
          { href: "/home/diy/search", label: "DIYer Search View" },
          { href: "/home/diy/profile", label: "DIYer Profile View" },
          { href: "/home/call", label: "Call Testing" },
          { href: "/home/mic-cam-test", label: "Mic & Cam Test" },
        ],
      ],
    },
  },

  {
    label: "Featured Tradies",
    href: "/home/tradie",
    content: {
      type: "products",
      layout: "grid",
      items: [
        [
          {
            title: "Hire a plumber",
            description:
              "Drainage, Fixtures, Pipes, Water Heaters, Water Treatment, Water Wells.",
            href: "/home/trade/search",
            src: "/skill-images/Plumbing/plumbing.jpg",
          },
          {
            title: "Hire an electrician",
            description:
              "Electrical Wiring, Lighting, Appliances, Security Systems, HVAC, Solar Panels.",
            href: "/home/trade/search",
            src: "/skill-images/Electrical/tv.jpg",
          },
          {
            title: "Carpentry",
            description:
              "Carpentry, Woodworking, Construction, Building, Remodeling.",
            href: "/home/trade/search",
            src: "/skill-images/Carpentry/ladder.jpg",
          },
        ],
        [
          {
            title: "Painting",
            description:
              "Never write from scratch again. Go from idea to blog in minutes.",
            href: "/painting",
            src: "/skill-images/Painting/painting.jpg",
          },
          {
            title: "Roofing",
            description:
              "Roofing, Roofing Materials, Roofing Installation, Roofing Repair, Roofing Maintenance.",
            href: "/roofing",
            src: "/skill-images/Roofing/roofing.jpg",
          },
          {
            title: "Flooring",
            description:
              "Flooring, Flooring Materials, Flooring Installation, Flooring Repair, Flooring Maintenance.",
            href: "/flooring",
            src: "/skill-images/Flooring/flooring.jpg",
          },
        ],
      ],
    },
  },

  {
    label: "Trades",
    href: "/home/trade",
    content: {
      type: "links",
      layout: "grid",
      items: generateTradeTypesLinks(),
    },
  },
  {
    label: "Diyers",
    href: "/home/diyer",
    content: {
      type: "links",
      layout: "grid",
      items: [
        [
          { href: "/home/diy/search", label: "Active Diyers" },
          { href: "/home/diy/search", label: "Newest Diyers" },
          { href: "/home/diy/search", label: "Featured Jobs" },
          { href: "/home/diy/profile", label: "DIYer Profile View" },
        ],
      ],
    },
  },
  {
    label: "Browse Jobs",
    href: "/home/job",
    content: {
      type: "links",
      layout: "grid",
      items: [
        [
          { href: "/home/job", label: "Featured Jobs" },
          { href: "/home/job", label: "All Jobs" },
          { href: "/home/job", label: "Completed Jobs" },
        ],
        [
          { href: "/home/job", label: "Carpentry Jobs" },
          { href: "/home/job", label: "Electrical Jobs" },
          { href: "/home/job", label: "Painting Jobs" },
          { href: "/home/job", label: "Plumbing Jobs" },
        ],
      ],
    },
  },
];
